/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react'

/** Common Components */
import UnderConstruction from '../../../../components/ui/underConstruction/UnderConstruction'

/**Wrapped Component */
import Financial from '../../Financial'

 const Profitability = () => {
  return (
   
    <UnderConstruction/>
 
  )
}
export default Financial(Profitability)